export default {
  bg: {
    dark: [require("./bg/dark/0.jpg"), require("./bg/dark/1.jpg")],
    light: [require("./bg/light/0.jpg"), require("./bg/light/1.jpg")]
  },
  character: {
    man: [
      require("./character/man/0.png"),
      require("./character/man/1.png"),
      require("./character/man/2.png"),
      require("./character/man/3.png"),
      require("./character/man/4.png"),
      require("./character/man/5.png"),
      require("./character/man/6.png"),
      require("./character/man/7.png")
    ],
    woman: [
      require("./character/woman/0.png"),
      require("./character/woman/1.png"),
      require("./character/woman/2.png"),
      require("./character/woman/3.png"),
      require("./character/woman/4.png"),
      require("./character/woman/5.png"),
      require("./character/woman/6.png"),
      require("./character/woman/7.png")
    ]
  },
  sys: {
    btn: {
      attrs: require("./sys/btn/attrs.png"),
      equip: require("./sys/btn/equip.png"),
      pack: require("./sys/btn/pack.png"),
      save: require("./sys/btn/save.png"),
      save1: require("./sys/btn/save_1.png"),
      shop: require("./sys/btn/shop.png"),
      exit0: require("./sys/btn/exit_0.png"),
      exit1: require("./sys/btn/exit_1.png"),
      battle1: require("./sys/btn/battle_1.png"),
      rank1: require("./sys/btn/rank_1.png")
    },
    msg: {
      bg: require("./sys/msg/bg.png"),
      scrollBar: require("./sys/msg/scrollBar.png")
    },
    map: {
      world: require("./sys/map/world.jpg")
    }
  },
  battle: {
    effects: [require("./battle/effects/0.gif")]
  },
  equip: [
    require("./equip/0.png"),
    require("./equip/1.png"),
    require("./equip/2.png"),
    require("./equip/3.png"),
    require("./equip/4.png"),
    require("./equip/5.png"),
    require("./equip/6.png"),
    require("./equip/7.png"),
    require("./equip/8.png"),
    require("./equip/9.png"),
    require("./equip/10.png"),
    require("./equip/11.png"),
    require("./equip/12.png"),
    require("./equip/13.png"),
    require("./equip/14.png"),
    require("./equip/15.png"),
    require("./equip/16.png"),
    require("./equip/17.png"),
    require("./equip/18.png"),
    require("./equip/19.png"),
    require("./equip/20.png"),
    require("./equip/21.png"),
    require("./equip/22.png"),
    require("./equip/23.png"),
    require("./equip/24.png"),
    require("./equip/25.png"),
    require("./equip/26.png"),
    require("./equip/27.png"),
    require("./equip/28.png"),
    require("./equip/29.png"),
    require("./equip/30.png"),
    require("./equip/31.png"),
    require("./equip/32.png"),
    require("./equip/33.png"),
    require("./equip/34.png"),
    require("./equip/35.png"),
    require("./equip/36.png"),
    require("./equip/37.png"),
    require("./equip/38.png"),
    require("./equip/39.png"),
    require("./equip/40.png"),
    require("./equip/41.png"),
    require("./equip/42.png")
  ],
  item: [
    require("./item/4.png"),
    require("./item/5.png"),
    require("./item/6.png"),
    require("./item/7.png"),
    require("./item/8.png"),
    require("./item/2.png"),
    require("./item/0.png"),
    require("./item/1.png"),
    require("./item/9.png"),
    require("./item/3.png")
  ]
};
